import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { logoutUser } from "../../redux/actions/userAction";
import {
  subscribeProdToken,
  getProdTokenStatus,
  ensureProdToken,
} from "../../helpers/prodToken";

// Non-blocking banner shown only when the prod token is genuinely unrecoverable
// (no sibling tab had it). It never redirects — the user keeps their place and
// can retry (a sibling may have opened) or re-log in.
const styles = {
  bar: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 16,
    padding: "10px 16px",
    backgroundColor: "#fff3cd",
    color: "#664d03",
    borderBottom: "1px solid #ffe69c",
    fontSize: 14,
    boxShadow: "0 1px 4px rgba(0,0,0,.15)",
  },
  button: {
    border: "1px solid #664d03",
    background: "transparent",
    color: "#664d03",
    borderRadius: 4,
    padding: "4px 10px",
    cursor: "pointer",
  },
  link: {
    color: "#664d03",
    fontWeight: 600,
    textDecoration: "underline",
    background: "transparent",
    border: "none",
    padding: 0,
    fontSize: 14,
    cursor: "pointer",
  },
};

const ProdTokenBanner = () => {
  const [missing, setMissing] = useState(getProdTokenStatus().missing);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => subscribeProdToken(({ missing }) => setMissing(missing)), []);
  // Same logout flow the app uses in SideBar: clear storage, reset the redux
  // user, then route to /login. Without clearing the stored user, LoginPage's
  // componentWillMount redirects straight back to /home.

  const relogin = () => {
    localStorage.clear();
    sessionStorage.removeItem("jwtP");
    dispatch(logoutUser());
    history.push("/login");
  };

  if (!missing) return null;

  return (
    <div style={styles.bar}>
      <span>
        Prod oturumu bu sekmede bulunamadı. İşlemleri sürdürmek için lütfen
        tekrar giriş yapın.
      </span>
      <button style={styles.button} onClick={() => ensureProdToken()}>
        Yeniden dene
      </button>
      <button style={styles.link} onClick={relogin}>
        Giriş yap
        </button>
    </div>
  );
};

export default ProdTokenBanner;
